import * as React from 'react';
import { Container } from 'flux/utils';
import SettingsStore from 'stores/SettingsStore';

import './styles/MessageBodyTranslationSwitcher.scss';

type Props = {
  showOriginal: boolean;
  originalLanguageCode: string;
  onToggleShowOriginal: () => void;
};

type State = {
  languages: { [code: string]: string };
};

class MessageBodyTranslationSwitcher extends React.Component<Props, State> {
  static getStores() {
    return [SettingsStore];
  }

  static calculateState(): State {
    return {
      languages: SettingsStore.getSetting('languages', 'secondary'),
    };
  }

  renderSwitcherBody = (langCode?: string) => {
    if (this.props.showOriginal) {
      return <span>&lt; Back to translation</span>;
    } else {
      if (langCode && this.state.languages[langCode]) {
        return (
          <span>
            Translated from <b>{this.state.languages[langCode]}</b> &gt;
          </span>
        );
      } else {
        return <span>Translated &gt;</span>;
      }
    }
  };

  render = () => (
    <div
      onClick={this.props.onToggleShowOriginal}
      data-test="message-body-translation-switcher"
      className="MessageBodyTranslationSwitcher">
      {this.renderSwitcherBody(this.props.originalLanguageCode)}
    </div>
  );
}

export default Container.create<Props, State>(MessageBodyTranslationSwitcher);
